import { render, staticRenderFns } from "./savematterposition.vue?vue&type=template&id=311b9355&scoped=true&"
import script from "./savematterposition.vue?vue&type=script&lang=js&"
export * from "./savematterposition.vue?vue&type=script&lang=js&"
import style0 from "./savematterposition.vue?vue&type=style&index=0&id=311b9355&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b9355",
  null
  
)

export default component.exports